import { conditionsGrouping } from '../../utils/addingCondition';
import { getExactKeyPath, isLogicGroup } from '../../filterQueryFormat/logic/LogicGroup';
import { isEventBasedFilterFamily } from '../../strategy/eventBasedFilters';
import { isPropertyNameAndValueCondition } from '../../strategy/propertyChangedFilterUtils';
import { useContext } from 'react';
import EditorAssetMembershipCondition from '../editor/EditorAssetMembershipCondition';
import EditorAssetMembershipConditionResponsive from '../editor/EditorAssetMembershipConditionResponsive';
import EditorCondition from '../editor/EditorCondition';
import EditorConditionResponsive from '../editor/EditorConditionResponsive';
import EditorEventBasedRelatedConditionsGroup from '../editor/EditorEventBasedRelatedConditionsGroup';
import EditorFilterGroupHeadCondition from '../editor/EditorFilterGroupHeadCondition';
import EditorFilterGroupHeadConditionResponsive from '../editor/EditorFilterGroupHeadConditionResponsive';
import EditorPropertyNameAndValueCondition from '../editor/EditorPropertyNameAndValueCondition';
import EditorPropertyNameAndValueConditionResponsive from '../editor/EditorPropertyNameAndValueConditionResponsive';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorConditionsGroupContainer = styled.div.withConfig({
  displayName: "ConditionEditor__EditorConditionsGroupContainer",
  componentId: "s2kgg2-0"
})(({
  theme
}) => ({
  '> * + *': {
    position: 'relative',
    marginTop: theme.space[800],
    '&::before': {
      content: '""',
      position: 'absolute',
      left: '25px',
      bottom: '100%',
      height: '33px',
      width: '1px',
      backgroundColor: theme.color['border-core-default']
    },
    '&.add-and-filter': {
      '&::before': {
        left: '24px'
      }
    }
  }
}));
const ConditionEditor = ({
  conditionPath: conditionPathProp,
  filterFamily: filterFamilyProp,
  inputUse,
  isNestedOrHeader
}) => {
  const {
    draftCondition,
    getIsUngated,
    internalDraftValue,
    props: {
      showAllFiltersInEditMode,
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const conditionPath = showAllFiltersInEditMode ? conditionPathProp : (draftCondition === null || draftCondition === void 0 ? void 0 : draftCondition.conditionPath) || conditionPathProp;
  const filterFamily = showAllFiltersInEditMode ? filterFamilyProp : (draftCondition === null || draftCondition === void 0 ? void 0 : draftCondition.filterFamily) || filterFamilyProp;
  const condition = getExactKeyPath(conditionPath, internalDraftValue);
  if (isLogicGroup(condition)) {
    // filter group head condition (e.g associated company, unified event, etc)
    return useOnePanel ? /*#__PURE__*/_jsx(EditorFilterGroupHeadConditionResponsive, {
      conditionPath: conditionPath,
      logicGroup: condition,
      inputUse: inputUse
    }) : /*#__PURE__*/_jsx(EditorFilterGroupHeadCondition, {
      conditionPath: conditionPath,
      logicGroup: condition,
      inputUse: inputUse
    });
  } else if (isEventBasedFilterFamily(filterFamily)) {
    // event based filter (FORM, CTA, PAGE_VIEW, etc.)
    return /*#__PURE__*/_jsx(EditorConditionsGroupContainer, {
      children: /*#__PURE__*/_jsx(EditorEventBasedRelatedConditionsGroup, {
        condition: condition,
        conditionPath: conditionPath,
        filterFamily: filterFamily,
        inputUse: inputUse
      })
    });
  } else if (conditionsGrouping.isAssetMembershipFilterFamily(filterFamily)) {
    // asset membership condition (list/import/workflow membership)
    return useOnePanel ? /*#__PURE__*/_jsx(EditorAssetMembershipConditionResponsive, {
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: filterFamily,
      inputUse: inputUse,
      isNested: isNestedOrHeader
    }) : /*#__PURE__*/_jsx(EditorAssetMembershipCondition, {
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: filterFamily,
      inputUse: inputUse,
      isNested: isNestedOrHeader
    });
  } else if (isPropertyNameAndValueCondition(condition)) {
    return useOnePanel ? /*#__PURE__*/_jsx(EditorPropertyNameAndValueConditionResponsive, {
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: filterFamily,
      getIsUngated: getIsUngated,
      inputUse: inputUse,
      isNested: isNestedOrHeader
    }) : /*#__PURE__*/_jsx(EditorPropertyNameAndValueCondition, {
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: filterFamily,
      getIsUngated: getIsUngated,
      inputUse: inputUse,
      isNested: isNestedOrHeader
    });
  } else {
    // simple condition
    return useOnePanel ? /*#__PURE__*/_jsx(EditorConditionResponsive, {
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: filterFamily,
      inputUse: inputUse,
      isNested: isNestedOrHeader
    }) : /*#__PURE__*/_jsx(EditorCondition, {
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: filterFamily,
      inputUse: inputUse,
      isNested: isNestedOrHeader
    });
  }
};
export default ConditionEditor;